import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface IVideoPlayerData {
  toView: string;
}

@Component({
  selector: "app-video-player",
  templateUrl: "./video-player.component.html",
  styleUrls: ["./video-player.component.scss"],
})
export class VideoPlayerComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: IVideoPlayerData) {}

  ngOnInit(): void {}
}
